import React, { useState } from "react";
import {
  Container,
  Button,
  TextField,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import FmdGoodOutlinedIcon from "@mui/icons-material/FmdGoodOutlined";
import "./FormMockUpScreen.css";
import logoSmall from "../assets/logo_small.png";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const FormScreen = () => {
  const [rating, setRating] = useState(3);
  const [selectedTip, setSelectedTip] = useState(null);
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [disable, setDisable] = useState(true);
  const [payFees, setPayFees] = useState(false);
  const navigate = useNavigate();

  const tips = [2, 3, 5, 7, 10, 20];

  const handleSubmit = () => {
    if (!acceptTerms) {
      const params = {
        icon: "error",
        title: "Ooops...",
        text: "Acepta los términos y condiciones",
      };
      Swal.fire(params);
    } else {
      navigate("/success");
    }
  };

  return (
    <Container className="app-container">
      <div className="d-flex justify-content-center ">
        <div className="mt-3">
          <img src={logoSmall} alt="Logo" className="logo" />
        </div>
        <div className="d-flex justify-content-end">
          <div className="d-flex flex-column text-end mt-4">
            <div className="row d-flex align-items-center">
              <div className="col-md-12" style={{ fontSize: "13px" }}>
                Establecimiento
              </div>
              <div className="col-md-12">
                <FmdGoodOutlinedIcon className="me-1" />
                <strong style={{ fontSize: "13px" }}>
                  Prototipo Café Las Tablas
                </strong>
              </div>
              <div className="col-md-12 text-secondary adress">
                Pl. del Lorem Ipsum, 12. 28013 Madrid
              </div>
              <div className="mt-1 d-flex align-items-center justify-content-end">
                <div className="d-flex align-items-center gap-2 px-1">
                  <span style={{ fontSize: "13px" }}> Valoración</span>
                  <StarIcon sx={{ color: "#ffb304", fontSize: "15px" }} />
                  <span className="text-secondary" style={{ fontSize: "13px" }}>
                    3.7
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Estrellas */}
      <div className="d-flex justify-content-center my-4">
        <div className="d-flex align-items-center gap-3">
          {[1, 2, 3, 4, 5].map((star) =>
            star <= rating ? (
              <StarIcon
                key={star}
                sx={{ color: "#ffb304", fontSize: "35px" }}
                onClick={() => setRating(star)}
              />
            ) : (
              <StarIcon
                key={star}
                sx={{ color: "#a0a4c1", fontSize: "35px" }}
                onClick={() => setRating(star)}
              />
            )
          )}
        </div>
      </div>

      {/* Comentario */}
      <div className="d-flex flex-column align-items-center">
        <strong className="mb-2">Valora el servicio recibido</strong>
        <TextField fullWidth multiline rows={3} variant="outlined" />
      </div>

      {/* Propina */}
      <div className="d-flex flex-column align-items-center text-center">
        <strong className="mt-2 mb-2 ">¿Quieres dejar una propina?</strong>
        <span className="propina px-4">
          Elige el monto y la propina será para el equipo que te ha atendido
        </span>
        <div className="d-flex flex-wrap justify-content-center px-3">
          {tips.map((tip) => (
            <div
              key={tip}
              className="d-flex justify-content-center opciones"
              style={{ flexBasis: "33.33%" }} // Asegura que haya solo 3 elementos por fila
            >
              <Button
                variant={selectedTip === tip ? "contained" : "outlined"}
                color="primary"
                onClick={() => {
                  setSelectedTip(tip);
                  setDisable(false);
                }}
                style={{
                  backgroundColor: selectedTip === tip ? "#66bc5f" : "#bfbfbf",
                  fontSize: "20px",
                  fontWeight: selectedTip === tip ? "bold" : "normal",
                  color: "white",
                  borderRadius: "10px",
                  border: "none",
                  boxShadow: "none",
                  height: "50px",
                  width: "75px",
                }}
              >
                {tip} €
              </Button>
            </div>
          ))}
        </div>
      </div>

      {/* Checkboxes */}
      <div className="d-flex flex-column align-items-center">
        <div className="row d-flex align-items-center px-3">
          <div className="col-md-12">
            <FormControlLabel
              control={
                <Checkbox
                  checked={payFees}
                  onChange={() => setPayFees(!payFees)}
                />
              }
              label="Pagar gastos de transacción (+0.00 €) 💚"
              sx={{
                "& .MuiTypography-root": {
                  fontSize: "13px",
                  opacity: "0.75",
                },
              }}
            />
          </div>
          <div className="col-md-12">
            <FormControlLabel
              control={
                <Checkbox
                  checked={acceptTerms}
                  onChange={() => setAcceptTerms(!acceptTerms)}
                />
              }
              label="Acepto los términos y condiciones"
              sx={{
                "& .MuiTypography-root": {
                  fontSize: "13px",
                  opacity: "0.75",
                },
              }}
            />
          </div>
        </div>
      </div>
      <div className="d-flex flex-column align-items-center px-3 pb-3">
        <div className="col-md-12">
          {/* Botón Continuar */}
          <Button
            fullWidth
            variant="contained"
            disabled={disable}
            style={{
              backgroundColor: disable ? "#dff2de" : "#66bc5f",
              fontSize: "18px",
              color: disable ? "#888583" : "white",
              borderRadius: "30px",
              padding: "10px",
              width: "260px",
              textTransform: "none",
              border: disable ? "1px solid #888583" : "none",
            }}
            onClick={() => {
              handleSubmit();
            }}
          >
            Continuar
          </Button>
        </div>
      </div>
    </Container>
  );
};

export default FormScreen;
